module.exports = __webpack_public_path__ + "i/abf728f1bdc23a3e9cf8469887969d82.png";